import { Participant } from '../../models/participant.model';
import { Signing } from '../../models/signing.model';

export interface SessionState {
  participant: Participant | null;
  signing: Signing | null;
  isLoading: boolean;
  error: string | null;
}

export const initialSessionState: SessionState = {
  participant: null,
  signing: null,
  isLoading: false,
  error: null,
};
